import BookFormCollection from './BookFormCollection';

export { default as BookFormCollectionResources } from './BookFormCollectionResources';
export { default as BookFormCollectionPlaceholder } from './BookFormCollectionPlaceholder';

export default BookFormCollection;
